import { WorkflowRole } from '@exam-management/common/types';
import { WorkflowStepCode } from '@exam-management/graphql';
import type { QSetReviewWorkflowStepCode } from '@exam-management/task-management';

export enum ExamDetailsVariant {
  HIDDEN = 'HIDDEN',
  READONLY = 'READONLY',
}

const variant = {
  [WorkflowRole.TASK_OWNER]: {
    [WorkflowStepCode.ReviewQsetTodo]: ExamDetailsVariant.READONLY,
    [WorkflowStepCode.ReviewQsetInReview]: ExamDetailsVariant.READONLY,
    [WorkflowStepCode.ReviewQsetReviewed]: ExamDetailsVariant.READONLY,
    [WorkflowStepCode.ReviewQsetDone]: ExamDetailsVariant.READONLY,
  },
  [WorkflowRole.SUBTASK_ASSIGNER]: {
    [WorkflowStepCode.ReviewQsetTodo]: ExamDetailsVariant.READONLY,
    [WorkflowStepCode.ReviewQsetInReview]: ExamDetailsVariant.READONLY,
    [WorkflowStepCode.ReviewQsetReviewed]: ExamDetailsVariant.READONLY,
    [WorkflowStepCode.ReviewQsetDone]: ExamDetailsVariant.READONLY,
  },
  [WorkflowRole.SUBTASK_ASSIGNEE]: {
    [WorkflowStepCode.ReviewQsetTodo]: ExamDetailsVariant.HIDDEN,
    [WorkflowStepCode.ReviewQsetInReview]: ExamDetailsVariant.READONLY,
    [WorkflowStepCode.ReviewQsetReviewed]: ExamDetailsVariant.READONLY,
    [WorkflowStepCode.ReviewQsetDone]: ExamDetailsVariant.READONLY,
  },
};

export default function getExamDetailsVariant(
  roles: { isOwner: boolean; isAssigner: boolean; isAssignee: boolean },
  workflowStepCode: QSetReviewWorkflowStepCode,
): keyof typeof ExamDetailsVariant | null {
  if (roles.isOwner) {
    return variant[WorkflowRole.TASK_OWNER][workflowStepCode];
  }

  if (roles.isAssigner && roles.isAssignee) {
    // REMARK: if users are assigner and assignee, they are always SUBTASK_ASSIGNEE
    return variant[WorkflowRole.SUBTASK_ASSIGNEE][workflowStepCode];
  }

  if (roles.isAssigner) {
    return variant[WorkflowRole.SUBTASK_ASSIGNER][workflowStepCode];
  }

  if (roles.isAssignee) {
    return variant[WorkflowRole.SUBTASK_ASSIGNEE][workflowStepCode];
  }

  return null;
}
